<template>
  <element>
    <nav-breadcrumb :menu="[{label: '客户列表'}, {label: '客户详情'}]"/>
    <el-row>
      <el-col class="grid-content bg-purple">
        <el-tabs v-model="tabName">
          <template>
            <!--<el-tab-pane label="客户信息" name="CustomerSummary">
              <template>
                <customer-detail-fang-component v-model="customerDetail"/>
              </template>
            </el-tab-pane>-->
            <el-tab-pane label="客户信息" name="CustomerSummary">
              <panel label="基本信息">
                <form-build
                  :form-data="customerDetail"
                  :form-rules="dataFormRules"
                  :form-columns="customerColumns"
                  class="formTable"
                  form-name="formSubmit2" ref="formBuildName2"
                />
              </panel>
              <panel label="证件图片" class="zhengjianxinxi">
                <div class="zhenjianyyzz zhenjianyyzz2">
                  <image-upload  v-model="customerDetail.pic__customerICFront" prefix="images/"></image-upload>
                  <label>本人身份证正面<span class="color-danger">*</span></label>
                </div>
                <div class="zhenjianyyzz zhenjianyyzz2">
                  <image-upload  v-model="customerDetail.pic__customerICBack" prefix="images/"></image-upload>
                  <label>本人身份证反面<span class="color-danger">*</span></label>
                </div>
                <div class="zhenjianyyzz zhenjianyyzz2">
                  <image-upload  v-model="customerDetail.pic__customerHukou1" prefix="images/"></image-upload>
                  <label>本人户口本主页<span class="color-danger">*</span></label>
                </div>
                <div class="zhenjianyyzz zhenjianyyzz2">
                  <image-upload  v-model="customerDetail.pic__customerHukou2" prefix="images/"></image-upload>
                  <label>本人户口本<span class="color-danger">*</span></label>
                </div>

                <div class="zhenjianyyzz zhenjianyyzz2">
                  <image-upload  v-model="customerDetail.pic__marriageCert" prefix="images/"></image-upload>
                  <label>结婚证明</label>
                </div>
                <div class="zhenjianyyzz zhenjianyyzz2">
                  <image-upload  v-model="customerDetail.pic__spouseICFront" prefix="images/"></image-upload>
                  <label>配偶身份证正面</label>
                </div>
                <div class="zhenjianyyzz zhenjianyyzz2">
                  <image-upload  v-model="customerDetail.pic__spouseICBack" prefix="images/"></image-upload>
                  <label>配偶身份证反面</label>
                </div>
                <div class="zhenjianyyzz zhenjianyyzz2">
                  <image-upload  v-model="customerDetail.pic__divorceCert" prefix="images/"></image-upload>
                  <label>离婚证</label>
                </div>
                <div class="zhenjianyyzz zhenjianyyzz2">
                  <image-upload  v-model="customerDetail.pic__singleCert" prefix="images/"></image-upload>
                  <label>单身证明</label>
                </div>

              </panel>
                <panel label="银行流水和征信证明等附件" class="zhengjianxinxi">

                    <div class="zhenjianyyzz zhenjianyyzz2">
                        <file-upload  v-model="customerDetail.att__bankStatement" prefix="images/"></file-upload>
                        <label>借款人银行流水</label>
                    </div>
                    <div class="zhenjianyyzz zhenjianyyzz2">
                        <file-upload  v-model="customerDetail.att__creditReport" prefix="images/"></file-upload>
                        <label>征信报告<span class="color-danger">*</span></label>
                    </div>
                    <div class="zhenjianyyzz zhenjianyyzz2">
                        <file-upload  v-model="customerDetail.pic__marriageCertII"></file-upload>
                        <label>婚档</label>
                    </div>
                    <div class="zhenjianyyzz zhenjianyyzz2">
                        <file-upload  v-model="customerDetail.att__bizFile"></file-upload>
                        <label>经营佐证</label>
                    </div>
                    <div class="zhenjianyyzz zhenjianyyzz2">
                        <file-upload  v-model="customerDetail.att__miscFile"></file-upload>
                        <label>其他资料</label>
                    </div>
                </panel>
              <panel label="评估信息">
                  <form-build
                      :form-data.sync="customerDetail"
                      :form-rules="customerRules"
                      :form-columns="asmColumns"
                      class="formTable"
                      form-name="formSubmit1" ref="formBuildName1"
                  />
              </panel>
            </el-tab-pane>
            <el-tab-pane label="抵押房屋" name="House">
                <panel label="房屋信息">
                    <!-- <div style="text-align: left;padding-top: 10px">
                         <el-button type="primary" size="mini" @click="addData()">添加</el-button>
                     </div>-->
                    <panel :label="'抵押物'+(idx+1)"  v-for="(item, idx) in customerDetail.properties" :key="idx" >
                        <!--<div style="text-align: right;padding-top: 10px">
                            <el-button type="primary" size="mini" @click="deleteData(idx)">删除</el-button>
                        </div>-->
                        <div v-for="(itemP, idxP) in item.pr__owners" :key="idxP">
                            <form-build
                                :form-data="itemP"
                                :form-rules="fangRulesP"
                                :form-columns="houseColumnsP"
                                class="formTable"
                            />
                            <br/>
                            <br/>
                        </div>
                        <form-build
                            :form-data="item"
                            :form-rules="fangRules"
                            :form-columns="houseColumns"
                            class="formTable"
                        />
                        <panel class="zhengjianxinxi">
                            <div class="zhenjianyyzz zhenjianyyzz2">
                                <image-upload  v-model="item.pr__propertyCert" prefix="images/"></image-upload>
                                <label>房产证<span class="color-danger">*</span></label>
                            </div>
                            <div class="zhenjianyyzz zhenjianyyzz2">
                                <image-upload  v-model="item.pr__propertyLand" prefix="images/"></image-upload>
                                <label>土地证</label>
                            </div>
                            <div class="zhenjianyyzz zhenjianyyzz2">
                                <image-upload  v-model="item.pr__propertyLogbook" prefix="images/"></image-upload>
                                <label>产调<span class="color-danger">*</span></label>
                            </div>
                        </panel>
                        <data-table
                            :table-data="{data:item.pr__values, propertyIdx:idx}"
                            :columns="columns"
                            :page.sync="page"
                            :filters.sync="filters"
                            :actions="actions"
                            :isPaginationShow="false"
                            ref="tableForm"
                        />
                        <div class="totalltxt tr of">
                            平均值： {{pjdjArr[idx]|formatMoney}}
                        </div>
                        <form-build
                            :form-data.sync="item"
                            :form-rules="customerRules2"
                            :form-columns="asmColumns2"
                            class="formTable"
                        />
                    </panel>
                </panel>
            </el-tab-pane>
            <el-tab-pane label="共借人" name="borrower">
              <panel>
                <el-checkbox true-label="true" false-label="false" label="共借人1" v-model="customerDetail.coborrowers[0].co__checked"></el-checkbox>
                <panel class="zhengjianxinxi" v-if="customerDetail.coborrowers[0].co__checked=='true'||customerDetail.coborrowers[0].co__checked==true">
                  <form-build
                    :form-data.sync="customerDetail.coborrowers[0]"
                    :form-rules="coRules"
                    :form-columns="coColumns"
                    class="formTable"
                    form-name="coSubmit1" ref="coBuildName1"
                    v-if="customerDetail.coborrowers[0].co__checked=='true'||customerDetail.coborrowers[0].co__checked==true"
                  />
                </panel>
                <panel class="zhengjianxinxi" v-if="customerDetail.coborrowers[0].co__checked=='true'||customerDetail.coborrowers[0].co__checked==true">
                  <div class="zhenjianyyzz zhenjianyyzz2"  v-if="customerDetail.coborrowers[0].co__checked=='true'||customerDetail.coborrowers[0].co__checked==true">
                    <image-upload  v-model="customerDetail.coborrowers[0].co__borrowerICFront" prefix="images/"></image-upload>
                    <label>本人身份证正面<span class="color-danger">*</span></label>
                  </div>
                  <div class="zhenjianyyzz zhenjianyyzz2"   v-if="customerDetail.coborrowers[0].co__checked=='true'||customerDetail.coborrowers[0].co__checked==true">
                    <image-upload  v-model="customerDetail.coborrowers[0].co__borrowerICBack" prefix="images/"></image-upload>
                    <label>本人身份证反面<span class="color-danger">*</span></label>
                  </div>
                    <div class="zhenjianyyzz zhenjianyyzz2">
                        <file-upload  v-model="customerDetail.coborrowers[0].co__borrowerHukou1"></file-upload>
                        <label>户口本</label>
                    </div>
                </panel>
              </panel>
              <panel>
                <el-checkbox true-label="true" false-label="false" label="共借人2" v-model="customerDetail.coborrowers[1].co__checked"></el-checkbox>
                <panel class="zhengjianxinxi" v-if="customerDetail.coborrowers[1].co__checked=='true'||customerDetail.coborrowers[1].co__checked==true">
                  <form-build
                    :form-data.sync="customerDetail.coborrowers[1]"
                    :form-rules="coRules"
                    :form-columns="coColumns"
                    class="formTable"
                    form-name="coSubmit2" ref="coBuildName2"
                    v-if="customerDetail.coborrowers[1].co__checked=='true'||customerDetail.coborrowers[1].co__checked==true"
                  />
                </panel>
                <panel class="zhengjianxinxi" v-if="customerDetail.coborrowers[1].co__checked=='true'||customerDetail.coborrowers[1].co__checked==true">
                  <div class="zhenjianyyzz zhenjianyyzz2"  v-if="customerDetail.coborrowers[1].co__checked=='true'||customerDetail.coborrowers[1].co__checked==true">
                    <image-upload  v-model="customerDetail.coborrowers[1].co__borrowerICFront" prefix="images/"></image-upload>
                    <label>本人身份证正面<span class="color-danger">*</span></label>
                  </div>
                  <div class="zhenjianyyzz zhenjianyyzz2"  v-if="customerDetail.coborrowers[1].co__checked=='true'||customerDetail.coborrowers[1].co__checked==true">
                    <image-upload  v-model="customerDetail.coborrowers[1].co__borrowerICBack" prefix="images/"></image-upload>
                    <label>本人身份证反面<span class="color-danger">*</span></label>
                  </div>
                    <div class="zhenjianyyzz zhenjianyyzz2">
                        <file-upload  v-model="customerDetail.coborrowers[1].co__borrowerHukou1"></file-upload>
                        <label>户口本</label>
                    </div>
                </panel>
              </panel>
              <panel>
                <el-checkbox true-label="true" false-label="false" label="共借人3" v-model="customerDetail.coborrowers[2].co__checked"></el-checkbox>
                <panel class="zhengjianxinxi" v-if="customerDetail.coborrowers[2].co__checked=='true'||customerDetail.coborrowers[2].co__checked==true">
                  <form-build
                    :form-data.sync="customerDetail.coborrowers[2]"
                    :form-rules="coRules"
                    :form-columns="coColumns"
                    class="formTable"
                    form-name="coSubmit3" ref="coBuildName3"
                    v-if="customerDetail.coborrowers[2].co__checked=='true'||customerDetail.coborrowers[2].co__checked==true"
                  />
                </panel>
                <panel class="zhengjianxinxi" v-if="customerDetail.coborrowers[2].co__checked=='true'||customerDetail.coborrowers[2].co__checked==true">
                  <div class="zhenjianyyzz zhenjianyyzz2"  >
                    <image-upload  v-model="customerDetail.coborrowers[2].co__borrowerICFront" prefix="images/"></image-upload>
                    <label>本人身份证正面<span class="color-danger">*</span></label>
                  </div>
                  <div class="zhenjianyyzz zhenjianyyzz2"  >
                    <image-upload  v-model="customerDetail.coborrowers[2].co__borrowerICBack" prefix="images/"></image-upload>
                    <label>本人身份证反面<span class="color-danger">*</span></label>
                  </div>
                    <div class="zhenjianyyzz zhenjianyyzz2">
                        <file-upload  v-model="customerDetail.coborrowers[2].co__borrowerHukou1"></file-upload>
                        <label>户口本</label>
                    </div>
                </panel>
              </panel>
              <panel>
                <el-checkbox true-label="true" false-label="false" label="共借人4" v-model="customerDetail.coborrowers[3].co__checked"></el-checkbox>
                <panel class="zhengjianxinxi" v-if="customerDetail.coborrowers[3].co__checked=='true'||customerDetail.coborrowers[3].co__checked==true">
                  <form-build
                    :form-data.sync="customerDetail.coborrowers[3]"
                    :form-rules="coRules"
                    :form-columns="coColumns"
                    class="formTable"
                    form-name="coSubmit4" ref="coBuildName4"
                    v-if="customerDetail.coborrowers[3].co__checked=='true'||customerDetail.coborrowers[3].co__checked==true"
                  />
                </panel>
                <panel class="zhengjianxinxi" v-if="customerDetail.coborrowers[3].co__checked=='true'||customerDetail.coborrowers[3].co__checked==true">
                  <div class="zhenjianyyzz zhenjianyyzz2"  >
                    <image-upload  v-model="customerDetail.coborrowers[3].co__borrowerICFront" prefix="images/"></image-upload>
                    <label>本人身份证正面<span class="color-danger">*</span></label>
                  </div>
                  <div class="zhenjianyyzz zhenjianyyzz2"  >
                    <image-upload  v-model="customerDetail.coborrowers[3].co__borrowerICBack" prefix="images/"></image-upload>
                    <label>本人身份证反面<span class="color-danger">*</span></label>
                  </div>
                    <div class="zhenjianyyzz zhenjianyyzz2">
                        <file-upload  v-model="customerDetail.coborrowers[3].co__borrowerHukou1"></file-upload>
                        <label>户口本</label>
                    </div>
                </panel>
              </panel>
              <panel>
                <el-checkbox true-label="true" false-label="false" label="共借人5" v-model="customerDetail.coborrowers[4].co__checked"></el-checkbox>
                <panel class="zhengjianxinxi" v-if="customerDetail.coborrowers[4].co__checked=='true'||customerDetail.coborrowers[4].co__checked==true">
                  <form-build
                    :form-data.sync="customerDetail.coborrowers[4]"
                    :form-rules="coRules"
                    :form-columns="coColumns"
                    class="formTable"
                    form-name="coSubmit5" ref="coBuildName5"
                    v-if="customerDetail.coborrowers[4].co__checked=='true'||customerDetail.coborrowers[4].co__checked==true"
                  />
                </panel>
                <panel class="zhengjianxinxi" v-if="customerDetail.coborrowers[4].co__checked=='true'||customerDetail.coborrowers[4].co__checked==true">
                  <div class="zhenjianyyzz zhenjianyyzz2"  >
                    <image-upload  v-model="customerDetail.coborrowers[4].co__borrowerICFront" prefix="images/"></image-upload>
                    <label>本人身份证正面<span class="color-danger">*</span></label>
                  </div>
                  <div class="zhenjianyyzz zhenjianyyzz2"  >
                    <image-upload  v-model="customerDetail.coborrowers[4].co__borrowerICBack" prefix="images/"></image-upload>
                    <label>本人身份证反面<span class="color-danger">*</span></label>
                  </div>
                    <div class="zhenjianyyzz zhenjianyyzz2">
                        <file-upload  v-model="customerDetail.coborrowers[4].co__borrowerHukou1"></file-upload>
                        <label>户口本</label>
                    </div>
                </panel>
              </panel>
            </el-tab-pane>
            <el-tab-pane  label="收款银行账户" name="bankInfo">
              <panel class="zhengjianxinxi">
                <form-build
                  :form-data.sync="customerDetail"
                  :form-rules="bankRules"
                  :form-columns="bankColumns"
                  class="formTable"
                  form-name="formSubmit4" ref="formBuildName4"
                />
              </panel>
              <panel class="zhengjianxinxi">
                <div class="zhenjianyyzz zhenjianyyzz2" >
                  <image-upload  v-model="customerDetail.pic__customerBankCardFront" prefix="images/"></image-upload>
                  <label>银行卡正面</label>
                </div>
              </panel>
            </el-tab-pane>
            <el-tab-pane label="评估审批" name="Approve">
              <el-steps :active="1000" class="step-shenpi">
                <el-step :title="'进件送签'"  :description="$moment(customerDetail.ac__createdDate).format('YYYY-MM-DD HH:mm:ss')">
                  <i class="step-start" slot="icon"></i>
                </el-step>
                <el-step v-for="(item, idx) in (customerDetail.approvals||[]).filter(item=>item.a__approvingDate)" class="step-spec" :description="$moment(item.a__approvingDate).format('YYYY-MM-DD HH:mm:ss')+Status2CN(item.a__approvingStatus)" :key="idx" >
                  <i class="step-mid" slot="icon"></i>
                  <div slot="title">{{Status2CN(item.a__approvalType)}} <br />{{item.a__approverName}}</div>
                </el-step>
                <el-step :title="'完成'" v-if="customerDetail.t__applicationStatus == 'Approved'" >
                  <i class="step-over" slot="icon"></i>
                </el-step>
                <el-step :title="'完成'" v-if="customerDetail.t__applicationStatus == 'Completed'" >
                  <i class="step-over" slot="icon"></i>
                </el-step>
              </el-steps>
              <panel>
                <data-table
                  :table-data="approvalArry"
                  :columns="tableColumns"
                  :is-pagination-show="false"
                />
              </panel>
            </el-tab-pane>
            <el-tab-pane label="还款银行账户" name="Bank">
              <data-table
                :table-data="BankArry"
                :columns="BankColumns"
                :actions="actions"
                :is-pagination-show="false"
              />

              <el-dialog :visible.sync="dialogVisible1" :title="dialogTitle">
                <form-build
                  form-name="ConfigDepartmentEditForm"
                  :form-data.sync="form"
                  :form-columns="formColumns"
                  :form-rules="formRules"
                  :form-buttons="formButtons"
                ></form-build>
              </el-dialog>

            </el-tab-pane>
          </template>
        </el-tabs>
      </el-col>
    </el-row>
    <div class="tr xzmt">
      <el-button @click="onSubmitEdit()">保存</el-button>
    </div>
    <el-dialog
      title="房价跟踪"
      :visible.sync="dialogVisible"
      width="45%">
      <house-history-price-component @getPrice="onGetPrice"></house-history-price-component>
    </el-dialog>
  </element>
</template>

<script>
  import xhr from '../../utils/xhr'
  import Status2CN from "../../filters/Status2CN";
  import {formatMoney} from "../../filters/CommonFilters";
  import moment from 'moment'
  import CustomerDetailFangComponent from '../components/CustomerDetailFangComponent'
  import CustomerHouseFangComponent from '../components/CustomerHouseFangComponent'
  import Panel from "../../components/Panel";
  import DataTableComponent from "../../components/DataTable";
  import FormBuildComponent from "../../components/FormBuild";
  import bankTypeOptions from "../../utils/bankTypeOptions"
  import HouseHistoryPriceComponent from "../components/HouseHistoryPriceComponent";
  export default {
    name: "CustomerEdit",
    components: {Panel,FormBuildComponent, DataTableComponent,HouseHistoryPriceComponent},
    data(){
      return {
          initStatus:false,
          hangyeOptions:[],
          regionOptions:[],
        tableData :{
          count: 0,
          data: [
            {
              pv__ckecked:'true',
              pv__source:'',
              pv__quote: '',
            },
          ]
        },
        page: 1,
        pageSize: 20,
        actionsF: [
          {
            label: '最新房价',
            class: 'el-button--primary',
            clickHandler: ()=>{
              this.dialogVisible = true
            }
          },
          {
            label: '新增',
            class: 'el-button--primary',
            clickHandler: ()=>{
              this.tableData.data.push({})
            }
          }
        ],
        filters: {
          form: {

          },
          columns: [

          ]
        },
        tableData :{
          count: 0,
          data: [
            {
              pv__ckecked:'true',
              pv__source:'',
              pv__quote: '',
            },
          ]
        },
        columns:[
          {
            label: '序号',
            type: 'index'
          },
          {
            label: '查询渠道',
            field: 'pv__source',
            component: 'el-input',
            type: 'text',
            rules: [
              {
                required: true,
                message: '查询渠道不能为空',
                trigger: 'blur'
              },
            ]
          },
          {
            label: '挂牌单价',
            field: 'pv__quote',
            component: 'el-input',
            type: 'number',
            rules: [
              {
                required: true,
                message: '挂牌单价不能为空',
                trigger: 'blur'
              },
            ],
            unit:'元/㎡',
          },
          {
            label: '操作',
            opts:[
              {
                label: '删除',
                class: 'el-icon-delete',
                clickHandler:(index, row)=>{
                  console.log(this.tableData.data.splice(index, 1))
                }
              }
            ]
          }
        ],
        dialogVisible: false,
        bankRules: {
          ba__customerBankAccountNo: [
            {
              required: true,
              message: '不能为空！'
            }
          ],
          ba__customerBankName: [
            {
              required: true,
              message: '不能为空！'
            }
          ],
        },
        productOptions :[],
        bankColumns:[
          {
            label: '户名',
            field: 'ba__customerName',
            type: 'text',
          },
          {
            label: '账号',
            field: 'ba__customerBankAccountNo',
            component: 'el-input',
            type: 'text',
          },
          {
            label: '开户银行',
            field: 'ba__customerBankName',
            component: 'el-input',
            type: 'text',
            span:24
          },
        ],
        coRules:{
          co__relationship: [
            {
              required: true,
              message: '不能为空！'
            }
          ],
          co__borrowerName: [
            {
              required: true,
              message: '不能为空！'
            }
          ],
          co__borrowerIC: [
            {
              required: true,
              message: '不能为空！'
            }
          ],
          co__borrowerContactNo: [
            {
              required: true,
              message: '不能为空！'
            }
          ],
        },
        coColumns:[
          {
            label: '与借款人关系',
            field: 'co__relationship',
            component: 'el-select',
            options:[
              {
                label:'配偶',
                value:'配偶'
              },
              {
                label:'父母',
                value:'父母'
              },
              {
                label:'兄弟',
                value:'兄弟'
              },
              {
                label:'姐妹',
                value:'姐妹'
              },
              {
                label:'子女',
                value:'子女'
              },
              {
                label:'朋友',
                value:'朋友'
              },
              {
                label:'其他',
                value:'其他'
              },
            ]
          },
          {
            label: '姓名',
            field: 'co__borrowerName',
            component: 'el-input',
            type: 'text',
          },
          {
            label: '身份证号码',
            field: 'co__borrowerIC',
            component: 'el-input',
            type: 'text',
          },
          {
            label: '手机号',
            field: 'co__borrowerContactNo',
            component: 'el-input',
            type: 'text',
          },
          {
            label: '住所地址',
            field: 'co__borrowerAddress',
            component: 'el-input',
            type: 'text',
            span:24
          },
        ],
        tabName: 'CustomerSummary',
        applicationId: this.$route.query['applicationId']||'',
        customerDetail:{
          coborrowers:[{},{},{},{},{}],
            properties:[]
        },
        customerRules: {
          asm__pledgeExAmount:[
            {
              required: false,
              message: '一抵余额不能为空！'
            }
          ],
          asm__approvedAmount: [
            {
              required: true,
              message: '核定贷款金额不能为空！'
            }
          ],
          asm__assessedUnitValue: [
            {
              required: true,
              message: '评估单价不能为空！'
            }
          ],
          asm__assessedTotalValue: [
            {
              required: true,
              message: '实际评估价不能为空！'
            }
          ],
          asm__pledgeRate: [
            {
              required: true,
              message: '抵押率不能为空！'
            }
          ],
        },
        customerRules2: {
              asm__pledgeExAmount:[
                  {
                      required: false,
                      message: '一抵余额不能为空！'
                  }
              ],
              asm__assessedUnitValue: [
                  {
                      required: true,
                      message: '评估单价不能为空！'
                  }
              ],
              asm__assessedTotalValue: [
                  {
                      required: true,
                      message: '实际评估价不能为空！'
                  }
              ],
              asm__pledgeRate: [
                  {
                      required: true,
                      max:100,
                      message: '抵押率不能为空！'
                  }
              ],
          },
        dataFormRules:{

          ba__customerName: [
            {
              required: true,
              message: '不能为空！'
            }
          ],
          ba__customerIC: [
            {
              required: true,
              message: '不能为空！'
            }
          ],
          ex__customerDOB: [
            {
              required: true,
              message: '不能为空！'
            }
          ],
          ba__customerContactNo: [
            {
              required: true,
              message: '不能为空！'
            }
          ],
          ex__customerSex: [
            {
              required: true,
              message: '不能为空！'
            }
          ],
          ex__customerJiguan: [
            {
              required: true,
              message: '不能为空！'
            }
          ],
          ex__customerHukou: [
            {
              required: true,
              message: '不能为空！'
            }
          ],
          ex__customerAddress: [
            {
              required: true,
              message: '不能为空！'
            }
          ],
          ex__customerMartialStatus: [
            {
              required: true,
              message: '不能为空！'
            }
          ],
          ba__amount: [
            {
              required: true,
              message: '不能为空！'
            }
          ],
          ba__productId: [
            {
              required: true,
              message: '不能为空！'
            }
          ],
          ba__interestRate: [
            {
              required: true,
              message: '不能为空！'
            }
          ],
          ba__repaymentCount: [
            {
              required: true,
              message: '不能为空！'
            }
          ],
        },
          fangRules: {
              pr__propertyOwner: [
                  {
                      required: true,
                      message: '不能为空！'
                  }
              ],
              pr__propertyLocation: [
                  {
                      required: true,
                      message: '不能为空！'
                  }
              ],
              pr__propertyUsage: [
                  {
                      required: true,
                      message: '不能为空！'
                  }
              ],
              pr__propertyArea: [
                  {
                      required: true,
                      message: '不能为空！'
                  }
              ],
              pr__propertyCertNo: [
                  {
                      required: true,
                      message: '不能为空！'
                  }
              ],
              /*ex__propertyLandNo: [
                {
                  required: true,
                  message: '不能为空！'
                }
              ],*/
          },
        approvalListcount:0,
        approvalList:{
        },
        BankList:{

        },
        tableColumns: [
          {
            label: '节点',
            field: 'node',
            formatter: function (r,c,v) {
              return Status2CN(v)
            }
          },
          {
            label: '操作人',
            field: 'approverName'
          },
          {
            label: '操作时间',
            field: 'time',
            formatter: function (r,c,v) {
              return v ? moment(v).format('YYYY-MM-DD HH:mm:ss') : ''
            }
          },
          {
            label: '操作结果',
            field: 'status'
          }, {
            label: '操作备注',
            field: 'remarks'
          },

        ],
          fangRulesP: {
              ow__ownerName: [
                  {
                      required: true,
                      message: '不能为空！'
                  }
              ],
          },
          houseColumnsP:[
              {
                  label: '序号',
                  field: 'ow__lineNo',
                  component: 'el-input',
                  type: 'number',
                  span:24
              },
              {
                  label: '姓名',
                  field: 'ow__ownerName',
                  component: 'el-input',
                  type: 'text',
              },
              {
                  label: '身份证号',
                  field: 'ow__ownerIC',
                  component: 'el-input',
                  type: 'text',
              },
              {
                  label: '手机号',
                  field: 'ow__ownerContactNo',
                  component: 'el-input',
                  span:24
              },
              {
                  label: '住所地址',
                  field: 'ow__ownerAddress',
                  component: 'el-input',
                  span:24
              },
          ],
          houseColumns:[
              {
                  label: '用途',
                  field: 'pr__propertyUsage',
                  component: 'el-select',
                  options:[
                      {
                          label:'住宅（自建房）',
                          value:'住宅（自建房）'
                      },
                      {
                          label:'住宅（商品房）',
                          value:'住宅（商品房）'
                      },
                      {
                          label:'住宅（安置房）',
                          value:'住宅（安置房）'
                      },
                      {
                          label:'商用',
                          value:'商用'
                      },
                      {
                          label:'商住两用',
                          value:'商住两用'
                      }
                  ],
              },
              {
                  label: '位置',
                  field: 'pr__propertyLocation',
                  component: 'el-input',
                  type: 'text',
              },
              {
                  label: '产权证号',
                  field: 'pr__propertyCertNo',
                  component: 'el-input',
                  type: 'text',
              },
              {
                  label: '面积',
                  field: 'pr__propertyArea',
                  component: 'el-input',
                  type: 'number',
                  props: {
                      step: 0.01
                  },
                  unit:'㎡'
              },
              {
                  label: '土地使用权面积',
                  field: 'pr__propertyLandArea',
                  component: 'el-input',
                  type: 'number',
                  props: {
                      step: 0.01
                  },
                  unit:'㎡'
              },
              {
                  label: '土地证',
                  field: 'pr__propertyLandNo',
                  component: 'el-input',
                  type: 'text',
              },
          ],
        approvalArry:{
          data:[],
          count:0,
        },
        BankArry:{
          data:[],
          count:0,
        },
        BankColumns: [
/*          {
            label: '账户类型',
            field: 'node',
            formatter: function (r,c,v) {
              return Status2CN(v)
            }
          },*/
          {
            label: '账号',
            field: 'cb__accountNo'
          },

          {
            label: '户名',
            field: 'cb__accountName'
          },
          {
            label: '开户银行',
            field: 'cb__bank'
          },
          /*{
            label: '备注',
            field: 'remarks'
          },*/
          {
            label: '操作',
            opts:[
              {
                label: '编辑',
                class: 'el-icon-edit',
                clickHandler: (index, row) => {
                  this.editItem(index, row)
                },
              },
           ]
          },
        ],
          actions: [
              {
                  label: '最新房价',
                  class: 'el-button--primary',
                  clickHandler: t=>{
                      this.dialogVisible = true
                      this.propertyIdx = t.data.propertyIdx
                  }
              },
              {
                  label: '新增',
                  class: 'el-button--primary',
                  clickHandler: t=>{
                      // console.log(t)
                      t.data.push({})
                  }
              }
          ],
        formButtons: [
          {
            label: '确认',
            type: 'primary',
            clickHandler:$refs=>{
              $refs.validate(valid=>{
                if(valid) {
                  this.onSubmit()
                }
              })
            }
          },
          {
            label: '取消',
            // type: 'primary',
            clickHandler:$refs=>{
              this.dialogVisible1 = false
            }
          }
        ],
        dialogVisible1:false,
        form: {
          c__customerId:'',
          cb__accountId:'',
          cb__accountNo: '',
          cb__accountName: '',
          cb__bank: ''
        },
        formRules: {
          cb__accountNo: [
            {
              required: true,
              message: '账号不能为空！'
            }
          ],
          cb__accountName: [
            {
              required: true,
              message: '户名不能为空！'
            }
          ],
          cb__bank: [
            {
              required: true,
              message: '开户银行不能为空！'
            }
          ],
        },
      }
    },
    components: {
      CustomerDetailFangComponent,
      CustomerHouseFangComponent,
      HouseHistoryPriceComponent
    },
    filters:{
      Status2CN
    },

    mounted() {
      this.getApplyingCustomerFang()
       /* this.getAdministrativeRegion()*/
    },
    computed: {
      dialogTitle() {
        return this.form.cb__accountNo  ? '编辑账户' : '新增账户'
      },
        pjdjArr() {
            return this.customerDetail.properties.map(item=> {
                //  console.log(item)
                let tempArr = item.pr__values.filter(item=>item.pv__quote)

                return tempArr.reduce((total, curr) => {
                    total = (Number(curr.pv__quote)||0) + Number(total)
                    return total
                }, 0)/tempArr.length
            })
        },
        watchChanged() {
            return this.customerDetail.properties.map(item=>({
                asm__assessedUnitValue: item.asm__assessedUnitValue,
                pr__propertyArea:item. pr__propertyArea,
            }))
        },
        watchChangedTwo() {
            return this.customerDetail.properties.map(item=>({
                asm__pledgeGrade: item.asm__pledgeGrade,
                asm__pledgeExAmount: item.asm__pledgeExAmount,
            }))
        },

        asmColumns(){
            return [


                {
                    label: '核定贷款金额',
                    field: 'asr__approvedAmount',
                    component: 'el-input',
                    type: 'number',
                    props: {
                        step: 0.01
                    },
                    unit:'元',
                    span:24
                },
                {
                    label: '其他资产情况',
                    field: 'asr__otherAssets',
                    component: 'el-input',
                    type: 'textarea',
                    span:24

                },
                {
                    label: '网络核查情况',
                    field: 'asr__internetCheck',
                    component: 'el-input',
                    type: 'textarea',
                    span:24

                },
                {
                    label: '评估情况',
                    field: 'asr__accessmentRemarks',
                    component: 'el-input',
                    type: 'textarea',
                    span:24

                },
                {
                    label: '结论',
                    field: 'asr__accessmentResult',
                    component: 'el-input',
                    type: 'textarea',
                    span:24

                },
                {
                    label: '审核意见',
                    field: 'a__remarks',
                    component: 'el-input',
                    type: 'textarea',
                    span:24

                },

            ]
        },
        asmColumns2(){
            return [
                {
                    label: '评估单价',
                    field: 'asm__assessedUnitValue',
                    component: 'el-input',
                    type: 'number',
                    props: {
                        step: 0.01
                    },
                    unit:'元/㎡'
                },
                {
                    label: '实际评估价',
                    field: 'asm__assessedTotalValue',
                    formatter: function (c,v) {
                        return formatMoney(v)
                    },
                    unit:'元'
                },
                {
                    label: '名义评估价',
                    field: 'asm__nominalTotalValue',
                    component: 'el-input',
                    type: 'number',
                    props: {
                        step: 0.01
                    },
                    unit:'元',
                    span:24
                },
                {
                    label: '名义评估价说明',
                    field: 'asm__nominalValueRemarks',
                    component: 'el-input',
                    type: 'textarea',
                    span:24
                },
                {
                    label: '抵押顺位',
                    field: 'asm__pledgeGrade',
                    component: 'el-select',
                    options:[
                        {
                            label:'一抵',
                            value:'一抵',
                        },
                        {
                            label:'二抵',
                            value:'二抵',
                        }
                    ],

                },
                {
                    label: '抵押率',
                    field: 'asm__pledgeRate',
                    component: 'el-input',
                    type: 'number',
                    props: {
                        step: 0.01
                    },
                    unit:'%',
                },
                {
                    label: '一抵余额',
                    field: 'asm__pledgeExAmount',
                    component: 'el-input',
                    type: 'number',
                    props: {
                        step: 0.01
                    },
                    unit:'元',
                    span:12
                },
                {
                    label: '一抵债权金额',
                    field: 'asm__pledgeRightsAmount',
                    component: 'el-input',
                    type: 'number',
                    props: {
                        step: 0.01
                    },
                    unit:'元',
                    span:12
                },
                {
                    label: '产调情况',
                    field: 'asm__pledgeRemarks',
                    component: 'el-input',
                    type: 'textarea',
                    span:24

                },

            ]
        },
      formColumns: {
        get() {
          return [
            {
              label: '账号',
              component: 'el-input',
              field: 'cb__accountNo',
              span: 24,
            },
            {
              label: '户名',
              component: 'el-input',
              field: 'cb__accountName',
              span: 24,
            },
            {
              label: '开户银行',
              component: 'el-input',
              field: 'cb__bank',
              span: 24,
            }
          ]
        }
      },
      customerColumns(){
        return [
          {
            label: '身份证号码',
            field: 'ba__customerIC',
          },
          {
            label: '客户姓名',
            field: 'ba__customerName',
          },
          {
            label: '性别',
            field: 'ex__customerSex',
            component: 'el-select',
            options:[
              {
                label:'男',
                value:'M'
              },
              {
                label:'女',
                value:'F'
              }
            ],

          },


          {
            label: '手机号',
            field: 'ba__customerContactNo',
            component: 'el-input',
            type: 'text',
          },
          {
            label: '出生日期',
            field: 'ex__customerDOB',
            component: 'el-date-picker',
            valueFormat: 'yyyy-MM-dd',
          },

          {
            label: '户口地区',
            field: 'ex__customerHukou',
            component: 'el-input',
            type: 'text',
          },

          {
            label: '籍贯',
            field: 'ex__customerJiguan',
            component: 'el-input',
            type: 'text',
            span:24
          },
          {
            label: '常住地址',
            field: 'ex__customerAddress',
            component: 'el-input',
            span:24
          },

          {
            label: '婚姻状况',
            field: 'ex__customerMartialStatus',
            component: 'el-select',
            options:[
              {
                label:'已婚',
                value:'已婚'
              },
              {
                label:'未婚',
                value:'未婚'
              },
              {
                label:'离异',
                value:'离异'
              },
              {
                label:'丧偶',
                value:'丧偶'
              }
            ]
          },
            {
                label: '行业类型',
                field: 'ex__industryId',
                component: 'el-cascader',
                props:{
                    emitPath:false,
                    showAllLevels:false,
                    expandTrigger:'hover',
                    clearable:true,
                    multiple:true

                },
                options:this.hangyeOptions
            },
          {
            label: '配偶姓名',
            field: 'ex__spouseName',
            component: 'el-input',
            type: 'text',
          },
          {
            label: '配偶身份证号码',
            field: 'ex__spouseIC',
            component: 'el-input',
            type: 'text',
          },
          {
            label: '配偶手机',
            field: 'ex__spouseContactNo',
            component: 'el-input',
            type: 'text',
          },
            {
                label: '配偶户口',
                field: 'ex__spouseHukou',
                component: 'el-input',
                type: 'text',
            },
            {
                label: '配偶生日',
                field: 'ex__spouseDOB',
                component: 'el-date-picker',
                valueFormat: 'yyyy-MM-dd'
            },

            {
                label: '配偶籍贯',
                field: 'ex__spouseJiguan',
                component: 'el-input',
                type: 'text',
            },
          {
            label: '申贷金额',
            field: 'ba__amount',
            component: 'el-input',
            type: 'number',
            props: {
              step: 0.01
            },
            unit:'元',
            span:12,
          },
          {
            label: '贷款产品',
            field: 'ba__productId',
            component: 'el-select',
            options: this.productOptions,
          },
          {
            label: '贷款利率',
            field: 'ba__interestRate',
            component: 'el-input',
            type: 'number',
            props: {
              step: 0.01
            },
            unit:this.unit

          },
          {
            label: '还款期数（月）',
            field: 'ba__repaymentCount',
            component: 'el-input',
            type: 'number',
            props: {
              step: 1
            },
          },
            {
                label: '业务城市',
                field: 't__regionName',
               /* component: 'el-select',
                options: this.regionOptions,*/
                span:24
            },
          {
            label: '贷款用途',
            field: 'ex__purpose',
            component: 'el-input',
            type:"textarea",
            span:24
          },
          {
            label: '客户来源',
            field: 'ba__channel',
          },

          {
            label: '分配渠道商',
            field: 'd__dealerName'
          },
          {
            label: '进件人',
            field: 'jinjian__userName'
          },
          {
            label: '渠道商审核人员',
            field: 'chushen__userName'
          },


        ]
      },
      numberAverage: function () {
        let arr = this.tableData.data.map(item=>item.pv__quote).filter(item=>item)
        return (arr.reduce(
          (total,curr)=> {
            total += Number(curr)||0
            return total
          }, 0
        ) / arr.length)||0
      }
    },
    watch:{
       /* 'customerDetail.t__regionId':function (newVal) {
            if(this.regionOptions.length>0) {
                this.customerDetail.t__regionName= (this.regionOptions.filter(item => item.value == newVal)[0] || {}).label
            }
        },*/
        watchChanged:function () {
            if(!this.initStatus) return
            else {

                this.changeValue()
            }
        },
        watchChangedTwo:function () {
            if(!this.initStatus) return
            else {

                this.changeValue2()
            }
        },
        'customerDetail.ba__amount':function () {
            if(!this.initStatus) return
            else {

                this.changeValue()
            }
        },

        'customerDetail.asr__approvedAmount':function () {
            if(!this.initStatus) return
            else {

                this.changeValue()
                this.customerDetail.ba__amount  =this.customerDetail.asr__approvedAmount
            }

        },
     /* 'customerDetail.asm__pledgeExAmount':function () {
        this.changeValue()
      },*/
      'customerDetail.ba__productId':function (newVal) {
        if(this.productOptions.length>0) {
          // let lendingFee = (this.productOptions.filter(item=>item.value== newVal)[0]||{}).p__lendingFee
          let interestRate = (this.productOptions.filter(item => item.value == newVal)[0] || {}).dp__interestRate
          // let lendingFeeType = (this.productOptions.filter(item=>item.value== newVal)[0]||{}).p__lendingFeeType
          let interestType = (this.productOptions.filter(item => item.value == newVal)[0] || {}).dp__interestType

          this.customerDetail.ba__interestRate = interestRate
          this.customerDetail.ba__productName = (this.productOptions.filter(item => item.value == newVal)[0] || {}).p__productName

          if (interestType == 'Yearly') {
            this.unit = "%（年利率）"
          }
          if (interestType == 'Daily') {
            this.unit = "%（日利率）"
          }
          if (interestType == 'Monthly') {
            this.unit = "%（月利率）"
          }
          this.customerDetail.ba__interestType = interestType
        }
        /*if(lendingFeeType=='Rate'){
          if(this.financingDetail.fi__totalAmount){
            this.financingDetail.fi__lendingFee = this.financingDetail.fi__totalAmount*lendingFee/100
          }
        }else{
          this.financingDetail.fi__lendingFee = lendingFee
        }*/

      },
    },
    methods: {
        /*getAdministrativeRegion: function () {
            xhr.getAdministrativeRegion(
                Object.assign({pageSize :0
                }, {}, {}),
                res=> {
                    try {
                        this.regionOptions = res.data.data.map(item=>{
                            return {
                                label: item.r__province+'/'+item.r__city+'/'+item.r__district,
                                value:item.r__regionId,
                            }

                        })
                    }catch(e){

                    }
                })

        },*/
        changeValue : function(){
            // this.customerDetail.ba__amount = 0
            let approvedAmounts = parseFloat(this.customerDetail.asr__approvedAmount)
            let assessedTotalValue = 0
            this.customerDetail.properties.forEach(item=>{
                //  console.log(item)
                item.asm__assessedTotalValue = item.asm__assessedUnitValue * item.pr__propertyArea
                item.asm__nominalTotalValue = item.asm__assessedTotalValue.toFixed(2)



                item.asm__pledgeRate = null
                assessedTotalValue = assessedTotalValue +(parseFloat(item.asm__assessedTotalValue)||0)
                if(item.asm__pledgeGrade=='一抵'){
                    if(item.asm__assessedTotalValue&&this.customerDetail.asr__approvedAmount&&this.customerDetail.asr__approvedAmount!=0){
                        //   item.asm__pledgeRate = (100*parseFloat(this.customerDetail.asr__approvedAmount)/parseFloat(item.asm__assessedTotalValue)).toFixed(2)
                    }

                }else{
                    if(item.asm__assessedTotalValue&&this.customerDetail.asr__approvedAmount&&item.asm__pledgeExAmount&&this.customerDetail.asr__approvedAmount!=0){
                        //  item.asm__pledgeRate = (100*(parseFloat(this.customerDetail.asr__approvedAmount)+parseFloat(item.asm__pledgeExAmount))/parseFloat(item.asm__assessedTotalValue)).toFixed(2)
                        approvedAmounts = approvedAmounts +parseFloat(item.asm__pledgeExAmount)
                    }
                }
            })
            this.customerDetail.properties.forEach(item=>{
                if(assessedTotalValue>0){
                    item.asm__pledgeRate = (100*approvedAmounts/assessedTotalValue).toFixed(2)
                }

            })


            this.customerDetail.properties = this.customerDetail.properties

        },
        changeValue2 : function(){
            // this.customerDetail.ba__amount = 0
            let approvedAmounts = parseFloat(this.customerDetail.asr__approvedAmount)
            let assessedTotalValue = 0
            this.customerDetail.properties.forEach(item=>{


                assessedTotalValue = assessedTotalValue +(parseFloat(item.asm__assessedTotalValue)||0)
                if(item.asm__pledgeGrade=='一抵'){
                    if(item.asm__assessedTotalValue&&this.customerDetail.asr__approvedAmount&&this.customerDetail.asr__approvedAmount!=0){
                        //   item.asm__pledgeRate = (100*parseFloat(this.customerDetail.asr__approvedAmount)/parseFloat(item.asm__assessedTotalValue)).toFixed(2)
                    }

                }else{
                    if(item.asm__assessedTotalValue&&this.customerDetail.asr__approvedAmount&&item.asm__pledgeExAmount&&this.customerDetail.asr__approvedAmount!=0){
                        //  item.asm__pledgeRate = (100*(parseFloat(this.customerDetail.asr__approvedAmount)+parseFloat(item.asm__pledgeExAmount))/parseFloat(item.asm__assessedTotalValue)).toFixed(2)
                        approvedAmounts = approvedAmounts +parseFloat(item.asm__pledgeExAmount)
                    }
                }
            })
            this.customerDetail.properties.forEach(item=>{
                if(assessedTotalValue>0){
                    item.asm__pledgeRate = (100*approvedAmounts/assessedTotalValue).toFixed(2)
                }

            })


            this.customerDetail.properties = this.customerDetail.properties

        },
      Status2CN,
      getFinanceProductFangList: function () {
        xhr.getFinanceProductFangList(
          Object.assign({
            'd.dealerId':this.customerDetail.ba__dealerId
          }, {}, {}),
          res=> {
            try {
              this.productOptions = []
              this.productOptions = res.data.data.map(item=>{
                return {
                  label: item.p__productName,
                  value:item.p__productId,
                  'dp__interestRate':item.dp__interestRate,
                  'dp__interestType':item.dp__interestType,
                  'p__productName':item.p__productName,
                }

              })
              this.customerColumns[13].options = this.productOptions||[]
              //console.log( this.productOptions  )
            }catch(e){

            }
          })

      },
      setApproval:function(){
        let arr=[]
        let count =2
        this.approvalArry.data.push(
          {
            node:'进件送签',
            approverName:'System',
            time:this.customerDetail.t__createdDate,
            status:'提交成功',
            remarks:'',

          }
        )
        console.log(this.approvalList)
        for(var i=0;i<this.approvalList.length;i++){
          let name =this.approvalList[i].a__approvalType



          this.approvalArry.data.push(
            {
              node:name,
              approverName:this.approvalList[i].a__approverName,
              time:this.approvalList[i].a__approvingDate,
              status:Status2CN(this.approvalList[i].a__approvingStatus),
              remarks:this.approvalList[i].a__remarks,

            }
          )
          count++


        }
        console.log('**********')
        this.approvalArry.count = count
        let num=0
        console.log(this.bankList)
        this.BankArry.data=[]
        for(var j=0;j<this.bankList.length;j++){
          this.BankArry.data.push(
            {
              cb__accountId:this.bankList[j].cb__accountId,
              cb__accountNo:this.bankList[j].cb__accountNo,
              cb__accountName:this.bankList[j].cb__accountName,
              cb__bank:this.bankList[j].cb__bank,

            }
          )
          num++
        }

        this.BankArry.count = num
       /* console.log(this.approvalArry)*/
      },
      getApplyingCustomerFang : function () {
        xhr.getApplyingCustomerFang({
          't.applicationId': this.$route.query['applicationId']
        }, res=>{
          try{
            if(res.data.status == 'success') {
              this.customerDetail = res.data.data
              this.tableData.data = this.customerDetail.values
              this.approvalList = res.data.data.approvals
              this.bankList = res.data.data.accounts
              this.approvalListcount = res.data.data.approvals.length
              this.setApproval()
              let interestType =  this.customerDetail.ba__interestType
              if( this.customerDetail.ba__dealerId) {
                this.getFinanceProductFangList()
              }
              let length = this.customerDetail.coborrowers.length
              for(var i=0;i<5-length;i++){
                this.customerDetail.coborrowers.push(
                  {
                    'co__checked':'false'
                  }
                )
              }
              if(interestType=='Yearly'){
                interestType =  this.customerDetail.ba__interestRate+"%（年利率）"
              }
              if(interestType=='Daily'){
                interestType =  this.customerDetail.ba__interestRate+"%（日利率）"
              }
              if(interestType=='Monthly'){
                interestType =  this.customerDetail.ba__interestRate+"%（月利率）"
              }
              this.customerDetail.interestType = interestType
                this.getIndustry(null,this.hangyeOptions)
                this.$nextTick(()=> {
                    this.initStatus = true
                })
            }
          }catch(e){}
        })
      },
        getIndustry:function(parentId,options){
            xhr.getIndustry(
                Object.assign({
                    pageSize:0
                }, {},{}),
                res=> {
                    try {
                        res.data.data.forEach(item=>{

                            let option = {
                            }
                            if(item.i__parentId==null){

                                option.label = item.i__name
                                option.value = item.i__industryId
                                console.log(option)
                                res.data.data.forEach(item1=>{
                                    if(item.i__industryId == item1.i__parentId){

                                        if(option.children){

                                        }else{
                                            option.children = []
                                        }
                                        let option1 = {
                                        }
                                        option1.label = item1.i__name
                                        option1.value = item1.i__industryId
                                        res.data.data.forEach(item2=>{
                                            if(item1.i__industryId == item2.i__parentId){
                                                if(option1.children){

                                                }else{
                                                    option1.children = []
                                                }
                                                option1.children.push({
                                                    label:item2.i__name,
                                                    value:item2.i__industryId,
                                                })
                                            }
                                        })
                                        option.children.push(option1)

                                    }
                                })
                                console.log(option)
                                options.push(option)
                            }

                            /*xhr.getIndustry(
                                Object.assign({
                                    parentId:item.i__industryId,
                                    pageSize:0
                                }, {},{}),
                                res1=> {
                                    try {
                                        let childrenOptions = []



                                        if(res1.data.count>0){
                                            this.getIndustry(item.i__industryId,childrenOptions)
                                            options.push({
                                                label:item.i__name,
                                                value:item.i__industryId,
                                                children:childrenOptions
                                            })
                                        }else{
                                            options.push({
                                                label:item.i__name,
                                                value:item.i__industryId,
                                            })

                                        }

                                    }catch(e){


                                    }
                                })*/

                        })
                    }catch(e){

                    }
                })

        },
      editItem(index, row) {
        if(typeof row == 'object') {
          this.form = Object.assign({}, row)
        }
        else {
          this.form = {
            c__customerId:'',
            cb__accountId:'',
            cb__accountNo: '',
            cb__accountName: '',
            cb__bank: ''
          }
        }

        this.dialogVisible1 = true
      },
      onSubmit:function () {
        this.form.c__customerId=this.customerDetail.t__customerId
        this.form.c__checked = true
        xhr.updateBank(
          this.form,
          res=>{
            try {
              if(res.data.status == 'success') {
                this.$message({
                  type: 'success',
                  message: '保存成功！'
                })
                this.dialogVisible1 = false
                this.getApplyingCustomerFang()
              }
              else {
                this.$message({
                  type: 'error',
                  message: '保存失败！'
                })
              }
            }catch (e) {

            }
          })
      },
      onGetPrice: function (priceList) {
        this.dialogVisible = false
        this.tableData.data = Object.keys(priceList).reduce( (prev, curr) => {
          prev.push({
            pv__source: curr,
            pv__quote: priceList[curr]
          })
          return prev
        }, [])
        console.log(priceList)
      },
      onSubmitEdit :function () {
/*        this.customerDetail.values = this.tableData.data
        this.customerDetail.values.forEach(item => {
          item.detail__checked = true
          item.pv__checked = true
          delete(item.pv__entryId)
        })
        this.customerDetail.values = this.customerDetail.values.filter(item=>item.pv__source)*/
          this.customerDetail.properties.forEach(item=>{
              item.pr__values.forEach(item1=>{
                  item1.pv__checked = true
                  delete(item1.pv__entryId)
              })
              item.pr__values = item.pr__values.filter(item=>item.pv__source)
          })


      /*  if(this.customerDetail.asm__approvedAmount> this.customerDetail.asm__assessedTotalValue){
          this.$alert('核定贷款金额不能大于核定贷款金额')
          return false
        }*/
          let next = true
          if(this.customerDetail.asr__approvedAmount>   this.customerDetail.properties.reduce((total, curr) => {
              total = (Number(curr.asm__assessedTotalValue)||0) + Number(total)
              return total
          }, 0)){
              this.$alert('核定贷款金额不能大于实际评估价')
              next = false
          }
          if(next){
              xhr.AddApplyingCustomerInfo(
                  this.customerDetail,
                  res=> {
                      try{
                          if(res.data.status == 'success') {

                          }else{

                              this.$message.error(res.data.msgs[0].text)
                          }
                          this.$router.push({
                              path: 'List'
                          })
                      }catch (e) {

                          this.$message.error(error.msgs[0].text)

                      }
                  }
              )
          }

      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/dealer/CustomerEdit.vue